import e from "./index.ce.vue.js";
import { defineAndRegisterElement as t } from "../../utils/register-element.js";
const r = t(e);
export {
  r as initDeliveryMethod
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-method/index.js
// module id = 1282
// module chunks = 67